/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { theme } from "@nordcloud/gnui";
import { Badge } from "~/components";
import { EnvType } from "~/models";

function displayEnvType(value: string, onRemove?: (values: string) => void) {
  switch (value) {
    case EnvType.PRODUCTION:
      return (
        <Badge
          color={theme.colors.actions[1]}
          text={EnvType.PRODUCTION}
          onRemove={onRemove}
        />
      );
    case EnvType.STAGING:
      return (
        <Badge
          color={theme.colors.actions[3]}
          text={EnvType.STAGING}
          onRemove={onRemove}
        />
      );
    case EnvType.DEVELOPMENT:
      return (
        <Badge
          color={theme.colors.actions[2]}
          text={EnvType.DEVELOPMENT}
          onRemove={onRemove}
        />
      );
    case EnvType.OTHER:
      return (
        <Badge
          color={theme.colors.actions[4]}
          text={EnvType.OTHER}
          onRemove={onRemove}
        />
      );
    default:
      return (
        <Badge
          color={theme.color.text.text01}
          text={EnvType.UNKNOWN}
          onRemove={onRemove}
        />
      );
  }
}

export { displayEnvType };
